export const blockIconsDeviceRestartAlt = (
	<span className='material-symbols-outlined'>restart_alt</span>
);
